import axios from 'axios';
import { getEnvVars } from '../utils/env-utils';
import { revokeToken } from '../utils/session-utils';

const { apiUri } = getEnvVars(window.location.host);

axios.defaults.baseURL = apiUri;

axios.defaults.headers.common['Cache-Control'] = 'no-cache';

export const authInstance = axios.create();

axios.interceptors.response.use(
  response => response,
  error => {
    if (401 === error.response.status) {
      alert('Session has expired');
      revokeToken();
      window.location = '/';
    } else {
      return Promise.reject(error);
    }
  }
);

export default axios;
